import React from 'react'
import DefaultTableLayout from './DefaultTableLayout'
import tableConfig from '../../config/TableConfig';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { savePreference, fetchPreferences, deletePreference } from "../../redux/slices/preferenceSlice";

function Index({ pageType }) {

    const config = tableConfig[pageType] || tableConfig[""];

    const dispatch = useDispatch();

    const {
        getAllLeads = () => { },
        getAllSourceList = () => { },
        getAllSubSourceList = () => { },
        createCombination = () => { },
        getRolesList = () => { },
        getCompanyList = () => { },
        editCombination = () => { },
        getSpecificCombination = () => { },
        getSubAdminDetailsById = () => { },
        deleteCombination = () => { },
    } = bindActionCreators(
        config.actions,
        dispatch
    );

    const { allLeadsData, loading } = useSelector(config.selector);
    const { columnsData, columnLoading, columnsError } = useSelector(config.columnSelector);

    return (
        <DefaultTableLayout
            allLeadsData={allLeadsData}
            getAllSourceList={getAllSourceList}
            getAllSubSourceList={getAllSubSourceList}
            loading={loading}
            columnType={config.columnType}
            createCombination={createCombination}
            pageType={pageType}
            fetchColumns={config.fetchColumns}
            allCombinationData={config.allCombinationData}
            isSearchable={config.search}
            isleadAction={config.leadAction}
            columnsData={columnsData}
            columnLoading={columnLoading}
            columnsError={columnsError}
            getAllLeads={getAllLeads}
            getRolesList={getRolesList}
            getCompanyList={getCompanyList}
            editCombination={editCombination}
            deleteCombination={deleteCombination}
            getSubAdminDetailsById={getSubAdminDetailsById}
            getSpecificCombination={getSpecificCombination}
            savePreference={savePreference}
            fetchPreferences={fetchPreferences}
            deletePreference={deletePreference}
        />
    )
}

export default Index;